import script from "./DashboardProgress.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardProgress.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardProgress.vue?vue&type=style&index=0&id=b5ce50f4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5ce50f4"]])

export default __exports__